export default function(http) {
  return {

      queryByPage(data){
        return http.json({
          url: `/push/message/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

      save(data){
        return http.json({
          url: '/push/message/save',
          data
        })
      },
      getInfo(data) {
        return http.json({
          url: `/push/message/get?id=${data.id}`
        })
      },
      copy(id) {
        return http.json({
          url: `/push/message/copy?id=${id}`
        })
      },
      sendMsg(data){
        return http.json({
          url: '/push/message/sendMsg',
          data
        })
      },
      delete(data){
        return http.json({
          url: `/push/message/delete?id=${data.id}`,
        })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/push.js